/**
 * Initial state of the render "subtitles" toggle for a project or library.
 *
 * The backend sets `default_subtitles_enabled: false` for sources whose videos
 * already carry burned-in captions (Frame.io edits), so our subtitles would
 * stack on top of them. Anything else, including an older backend that does
 * not send the field, keeps subtitles on.
 *
 * Typed as `object` because the generated query types predate the field.
 */
export function resolveDefaultSubtitlesEnabled(source: object | null | undefined): boolean {
  if (!source) return true;
  return (source as { default_subtitles_enabled?: unknown }).default_subtitles_enabled !== false;
}
